module.exports = __webpack_public_path__ + "static/media/award1@2x.66b63adb.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_42/imgs/award1@2x.png
// module id = 1000
// module chunks = 0